<mat-nav-list class="sidenav-list">
  <div class="sidenav-list-container">
    <a *ngFor="let item of routes" mat-list-item [routerLinkActive]="'active-link'" [routerLink]="['/', item.path]" (click)="menuClicked()">
      <mat-icon class="sidenav-icon" color="primary">{{ item.data.icon }}</mat-icon>
      <span class="menu-name">{{ item.data.text }}</span>
    </a>
  </div>

  <!-- Logout fixed at bottom -->
  <div class="logout-container">
    <a mat-list-item [routerLink]="['']" >
      <mat-icon class="sidenav-icon" color="primary">logout</mat-icon>
      <span class="menu-name">Logout</span>
    </a>
  </div>
</mat-nav-list>
